"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIconButton = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _button = require("../../button");
var _paginationTheme = require("../paginationTheme");
/**
 * TODO: Remove this component when the Button component's `small` variant is resized to 28px out of the box
 */
const StyledIconButton = (0, _styled.default)(_button.Button)(_ref => {
  let {
    themeMode
  } = _ref;
  return `
    height: ${_paginationTheme.paginationTheme.iconButton.height(themeMode)};
    width: ${_paginationTheme.paginationTheme.iconButton.width(themeMode)};
`;
});
exports.StyledIconButton = StyledIconButton;
//# sourceMappingURL=StyledIconButton.js.map